var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-layout-container"},[_c('BaseMenu',{attrs:{"menu-items":_vm.menuItems}}),_c('main',{staticClass:"page-wrapper"},[_c('router-view')],1),_c('BaseFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }